import { Button, Modal, ModalBody, ModalHeader } from 'react-bootstrap';
import { MarketSignal } from '@/modules/market-signals/model/market-signals/market-signal';
import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import marketSignalApi from '@/modules/market-signals/api/market-signal-api';
import { Page } from '@/shared/pagination/export';
import { SignalEntryComponent } from '@/modules/market-signals/components/market-signals/signal-entry-component';
import { uniqueById } from '@/modules/market-signals/util/unique-by-id';

export default function MarketSignalSourceModal({
  show,
  setShow,
  signal,
  entry: MarketSignalScrollerEntry,
}: {
  show: boolean;
  setShow: () => void;
  signal: MarketSignal;
  entry: SignalEntryComponent;
}) {
  const [page, setPage] = useState<Page<MarketSignal>>();
  const [name, setName] = useState<string>();

  useEffect(() => {
    if (show && signal && signal.infoSources.length > 0) {
      setName(signal.infoSources.map(s => s.name).join(', '));

      Promise.allSettled(
        signal.infoSources.map(s => marketSignalApi.getSignalsByInfoSource(s.scheme, s.code)),
      ).then(results => {
        const pages = results
          .filter((r): r is PromiseFulfilledResult<Page<MarketSignal>> => r.status === 'fulfilled')
          .map(r => r.value);
        if (pages.length === 0) return;

        const content = uniqueById(pages.flatMap(p => p.content)).sort(
          (a, b) => dayjs(b.dateCreated).valueOf() - dayjs(a.dateCreated).valueOf(),
        );

        setPage({ ...pages[0], content });
      });
    }
  }, [show, signal]);

  if (!show) return <span key={'source-modal-off-' + signal._id}></span>;

  return (
    <Modal
      show={show}
      onBackdropClick={setShow}
      onHide={setShow}
      key={'source-modal-' + signal._id}
    >
      <ModalHeader className={'d-flex justify-content-between'}>
        {name}
        <Button onClick={setShow} variant={'warning'}>
          Close
        </Button>
      </ModalHeader>
      <ModalBody className={'small'}>
        {page &&
          page.content.map((value, index) => (
            <div key={'source-history-' + value._id} className={'mb-2'}>
              <MarketSignalScrollerEntry signal={value} />
            </div>
          ))}
      </ModalBody>
    </Modal>
  );
}
